var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLinkedinRounded = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 24.9988C18.6276 24.9988 24 19.626 24 12.9984C24 6.37094 18.6276 0.998047 12.0002 0.998047C5.37236 0.998047 0 6.37094 0 12.9984C0 19.626 5.37236 24.9988 12.0002 24.9988ZM5.19922 6.9397C5.19922 6.024 5.94235 5.2814 6.85823 5.2814C7.77411 5.2814 8.51653 6.024 8.51653 6.9397C8.51653 7.85576 7.77411 8.59819 6.85823 8.59819C5.94235 8.59819 5.19922 7.85576 5.19922 6.9397ZM5.19922 19.4959V12.5346V10.0198H8.51653V19.4959H5.19922ZM19.3416 12.9294C19.117 11.143 18.2967 10.0198 15.8816 10.0198C14.4495 10.0198 13.4877 10.5516 13.0944 11.2982H13.0535V10.0198H10.4116V19.4959H13.173V14.7992C13.173 13.5604 13.4072 12.3614 14.9392 12.3614C16.4489 12.3614 16.5704 13.7772 16.5704 14.8789V19.4959H19.4138V14.2884H19.4141C19.4141 13.8028 19.3939 13.3478 19.3416 12.9294Z",
    fill: "#B0BEC5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinRounded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LinkedinRounded.2d4ed06e.svg";
export { ForwardRef as ReactComponent };